import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/industries/page.tsx");
